export default "__VITE_ASSET__BgSY5ziw__"